import { RootState } from "redux/rootReducer";

export const selectIsDownloadingConsultationCSV = (state: RootState) =>
  state.downloadConsultationCSV.loading;
export const selectDownloadConsultationCSVError = (state: RootState) =>
  state.downloadConsultationCSV.error;
export const downloadConsultationCSVDataResponse = (state: RootState) =>
  state.downloadConsultationCSV.downloadConsultationCSVResponse;
